import getNaturalTimeString from "../basic";
import { useEffect, useState } from "react";

import { ajaxor2 } from '../basic';

// props.me.action.content
// props.me.action_type
// props.me.created_at
// props.me.message

// props.me.target.content
// props.me.target.id
// props.me.target.images[0].archived_url
// props.me.target.images[0].high_quality_url
// props.me.target.images[0].optimized_url
// props.me.target.post_type

// props.me.user.id


// props.me.user.profile_picture[0].archived_url
// props.me.user.profile_picture[0].high_quality_url
// props.me.user.profile_picture[0].optimized_url
// props.me.user.username

// 프사 정석
// (props.me.user.profile_picture
//     && props.me.user.profile_picture[0]
//     && (props.me.user.profile_picture[0].high_quality_url
//         || props.me.user.profile_picture[0].optimized_url
//         || props.me.user.profile_picture[0].archived_url)
// ) || '/assets/images/ico-gnb-profile.png'


const messageMap={
    "": "",
    "callout": "회원님을 언급하였습니다.",
    "follow": "회원님을 팔로우 합니다.",
    "like": "회원님의 사진을 좋아합니다.",
    "comment": "회원님의 게시글에 댓글을 달았습니다.",
    "scrapbook_item": "회원님의 사진을 스크랩 하였습니다.",
};

export default props=>{
    if(!props.me) return <></>;

    const [vItems, setItems] = useState([]);

    useEffect(()=>{
        if (props.me.target_type != "snap_post") return;

        // 각각알림에 대해, 상세정보에서 썸네일이미지들을 채운다.
        ajaxor2({
            url: "/inspiration/single/" + props.me.target_id, // 컨텐츠 상세정보
            callback: callback
        });
        function callback(rd){
            setItems(rd.images);
        }

        return ()=>{;};
    }, []);
    const jsx = (<div className="">
        <style jsx>{`
.dib {
    vertical-align: top;
}

.psa {
    margin: 0 16px 0 0;
}

.item{
    font-size: 14px;
    color: #343a40;

    padding: 12px 16px 0;

    text-align: left;
}

.item.highlight{
    background-color: #55d5ce;
    opacity: 0.1;
}

.nickname{
    font-size: 14px;
    color: #343a40;
    text-align:left;
  letter-spacing: -0.25px;
  color: #343a40;
}




.message {
    font-size: 12px;
    color: #868e96;
    text-align:left;
    line-height: 1.67;
    letter-spacing: -0.25px;
    color: #868e96;

    padding-top: 3px;
}

.thumbnails{
    width: 180px;
    overflow: hidden;
    white-space: pre;
    
    padding: 8px 0;
    border-bottom: solid 1px #dee2e6;
}

.thumbnails img{
    padding: 0 8px 0 0;
}

.right{
    font-size: 10px;
    float:right;
    padding-top: 5px;
    color: #adb5bd;
}

.iimg {
    width: 56px;
    height: 48px;
}

div.iimg {
    width: 48px;
    display: inline-block;
    margin: 0 8px 0 0;

    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
}

`}</style>

        <div className="item">
            <a href={"/person/Blog?userid=" + (props.me.user && props.me.user.id)}>
                <div className="dib round-psa psa">
                    {/* <img src="/assets/images/ico-empty.svg" /> */}
                    <img src={props.me.user && props.me.user.profile_picture[0]
                        ? props.me.user.profile_picture[0].optimized_url
                        : "/assets/images/ico-empty.svg"
                    }/>
                </div>
            </a>
            <div className="dib center">
                <a href={"/person/Blog?userid=" + (props.me.user && props.me.user.id)}>
                    <div className="nickname">{props.me.user && props.me.user.username}</div>
                </a>
                <div className="message">{messageMap[props.me.action_type]}</div>
                <a href={"/community/" + props.me.target_id}>
                    <div className="thumbnails mouse-aa"
                        // onClick={e => location.href = "/community/" + props.me.target_id}
                    >
                        {vItems.map((v,i)=>(
                            // <img key={i} className="iimg" src={v.optimized_url} />
                            <div key={i} className="iimg" style={{ backgroundImage: "url("+v.optimized_url+")"}} />
                        ))}
                    </div>
                </a>
                
            </div>
            <div className="right">
                {getNaturalTimeString(props.me.created_at)}
            </div>
        </div>


    </div>);

    return jsx;
};

